import { LOAD_STATE } from '@/shared/types'
import type { AuthorCorrelationResponse } from '@/server/types'
import { getAuthorCorrelationRankApi } from '@/server'

export function logicAuthorCorrelationRank() {
  const state = ref(LOAD_STATE.INIT)
  const data = ref<AuthorCorrelationResponse[]>([])

  async function getRankData() {
    const res = await useLoadState({
      state,
      key: `相关资讯`,
      onlyClient: true,
      fn: () => getAuthorCorrelationRankApi(),
    })

    if (res && res.data)
      data.value = res.data
  }

  return {
    state,
    data,
    getRankData,
  }
}
